export const localStorage = Object.freeze({
  JWT_TOKEN: 'ihpa_jwt',
  WEB_URL: 'ihpa_web_url',
});

export const MARKETING_PAGE = 'https://profilesphere.com/';
